"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var AcdcContext_1 = require("./AcdcContext");
var useAcdcPopupProps_1 = __importDefault(require("./useAcdcPopupProps"));
var useForkRef_1 = __importDefault(require("./utils/useForkRef"));
var useAcdcScrollerProps = function () {
    var _a = AcdcContext_1.useAcdcElementRegistryContext(), getOptionElement = _a.getOptionElement, setScrollerElement = _a.setScrollerElement;
    var ownRef = react_1.useRef(null);
    var _b = __read(useAcdcPopupProps_1.default(), 1), _c = _b[0], popupRef = _c.ref, props = __rest(_c, ["ref"]);
    var ownPopupRef = useForkRef_1.default(ownRef, popupRef);
    var ref = useForkRef_1.default(ownPopupRef, setScrollerElement);
    var _d = AcdcContext_1.useAcdcContext().state, keyboardHighlightedIndex = _d.keyboardHighlightedIndex, isOpen = _d.isOpen;
    react_1.useEffect(function () {
        if (!isOpen
            || keyboardHighlightedIndex === null
            || ownRef.current === null) {
            return;
        }
        var optionEl = getOptionElement(keyboardHighlightedIndex);
        if (optionEl) {
            try {
                scroll_into_view_if_needed_1.default(optionEl, {
                    boundary: ownRef.current,
                    block: 'nearest',
                    scrollMode: 'if-needed',
                    behavior: 'smooth',
                });
            }
            catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    console.groupCollapsed('AcdcScroller: caught scrolling error');
                    console.warn('Most probably you change or remove the ref after being highlighted');
                    console.warn('To avoid this error, try using a consistent ref for an index');
                    console.warn(e);
                    console.groupEnd();
                }
            }
        }
    }, [isOpen, keyboardHighlightedIndex, getOptionElement]);
    return react_1.useMemo(function () { return [
        __assign({ ref: ref }, props),
    ]; }, [ref]);
};
exports.default = useAcdcScrollerProps;
